export default "__VITE_ASSET__6acaa941__"